import { render, staticRenderFns } from "./bsFooter.vue?vue&type=template&id=745105d4&scoped=true&"
import script from "./bsFooter.vue?vue&type=script&lang=js&"
export * from "./bsFooter.vue?vue&type=script&lang=js&"
import style0 from "./bsFooter.vue?vue&type=style&index=0&id=745105d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745105d4",
  null
  
)

export default component.exports